import {
  GETREFUNDDETAILSADMIN_SUCCESS,
  GETREFUNDDETAILSADMIN_FAILED,
  LOADING_GETREFUNDDETAILSADMIN,
  NETWORK_ERROR_GETREFUNDDETAILSADMIN,
  RESET_GETREFUNDDETAILSADMIN,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAdminGetRefundDetails = () => {
  return { type: RESET_GETREFUNDDETAILSADMIN };
};

const adminGetRefundDetails = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETREFUNDDETAILSADMIN });
  await partnerServices
    .post("getRefundDetails", userData, {
      headers: { AuthToken: authTokenIs },
    })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch({
            type: GETREFUNDDETAILSADMIN_SUCCESS,
            payload: res.data,
          });
          break;
        default:
          dispatch({ type: GETREFUNDDETAILSADMIN_FAILED, payload: res.data });
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETREFUNDDETAILSADMIN,
        payload: err,
      });
    });
};

export { adminGetRefundDetails, resetAdminGetRefundDetails };
